// extracted by mini-css-extract-plugin
export default {"categoriesDropdown":"CategoryDropdown_categoriesDropdown__ob7Fn","container":"CategoryDropdown_container__IsrSH"};